import i18next from 'i18next';
import type { i18n } from 'i18next';
import enBundle from './locales/en.json';

/**
 * Build an i18next instance with the room-locale bundle loaded.
 *
 * Architecture §7: Phase 1 ships `'en'` only; the locale parameter exists
 * so the selector is wired end-to-end now and adding locale #2 is a bundle
 * change, not a code change. The room-level locale value is hardcoded
 * client-side in Phase 1 — no `RoomSettings.locale`, no `joinOrCreate`
 * locale plumbing (deferred until locale #2; see convention doc).
 *
 * Returns a NEW instance per call (`i18next.createInstance()`), not the
 * global singleton. Epic 13 will create one at app boot and pass it to
 * `react-i18next`'s provider.
 */
export async function initI18n(locale: 'en' = 'en'): Promise<i18n> {
  const instance = i18next.createInstance();
  await instance.init({
    lng: locale,
    fallbackLng: 'en',
    resources: { en: { translation: enBundle } },
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return instance;
}
